// extracted by mini-css-extract-plugin
module.exports = {"green":"#7fdb6a","blue":"#0e68ce","yellow":"#eedc31","brown":"#966842"};